import { Field } from 'formik';
import { FieldProps } from 'formik/dist/Field';
import React from 'react';
import { Checkbox } from 'ui';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
}

export const FormikCheckbox: React.FC<Props> = ({
  children,
  name,
  id,
  ...props
}) => {
  return (
    <label className="block" htmlFor={id || name}>
      <Field name={name} type="checkbox">
        {({ field }: FieldProps) => (
          <Checkbox className="mr-2" id={id || name} {...props} {...field} />
        )}
      </Field>

      {children}
    </label>
  );
};
